import { ref, computed } from 'vue';
import svgPreloader from '../services/svgPreloader';

const isAppLoading = ref(true);
const loadingProgress = ref(0);
const svgLoadingStates = ref(new Map());

export function useSVGLoader() {
  const setSVGLoading = (svgPath, isLoading) => {
    svgLoadingStates.value.set(svgPath, isLoading);
  };

  const isSVGLoading = (svgPath) => {
    return svgLoadingStates.value.get(svgPath) || false;
  };

  const isSVGLoaded = (svgPath) => {
    return svgPreloader.isSVGLoaded(svgPath);
  };

  const preloadSVG = async (svgPath) => {
    if (isSVGLoaded(svgPath)) {
      return svgPath;
    }

    setSVGLoading(svgPath, true);
    
    try {
      const result = await svgPreloader.preloadSVG(svgPath);
      setSVGLoading(svgPath, false);
      return result;
    } catch (error) {
      setSVGLoading(svgPath, false);
      console.error(`Failed to preload SVG: ${svgPath}`, error);
      return null;
    }
  };

  const waitForSVG = (svgPath, timeout = 5000) => {
    return new Promise((resolve) => {
      if (isSVGLoaded(svgPath)) {
        resolve(svgPath);
        return;
      }

      const checkInterval = 100;
      let elapsed = 0;
      
      const interval = setInterval(() => {
        elapsed += checkInterval;
        
        if (isSVGLoaded(svgPath)) {
          clearInterval(interval);
          resolve(svgPath);
        } else if (elapsed >= timeout) {
          clearInterval(interval);
          console.warn(`SVG loading timeout: ${svgPath}`);
          resolve(null);
        }
      }, checkInterval);
    });
  };

  return {
    isAppLoading: computed(() => isAppLoading.value),
    loadingProgress: computed(() => loadingProgress.value),
    setSVGLoading,
    isSVGLoading,
    isSVGLoaded,
    preloadSVG,
    waitForSVG,
    setAppLoading: (loading) => { isAppLoading.value = loading; },
    setLoadingProgress: (progress) => { loadingProgress.value = progress; }
  };
}